module.exports = __webpack_public_path__ + "img/43.2.TN.958bbb3a.png";